import { commonSlice } from "./commonSlice";
import { historySlice } from "./historySlice";
import { designSlice } from "./designSlice";
import { snackbarSlice } from "./snackbarSlice";
import { creditSlice } from "./creditSlice";
import { whatsNewSlice } from "./whatsNewSlice";
import { chatbotSlice } from "./chatbotSlice";
import { guidanceSlice } from "./guidanceSlice";
import { notificationsSlice } from "./notificationsSlice";
import { siteImagesSlice } from "./siteImagesSlice";
import { reportsSlice } from "./reportsSlice";

/**
 * The app's reducer map — the ONE place a slice is registered. `store/index.ts` builds the app
 * singleton from it, and `test-utils/store.ts` builds fresh per-test stores from the same map, so a
 * slice registered here is automatically present in both. Keep this file free of side effects: the
 * Sentry enhancer and anything else app-only belong in `store/index.ts`.
 */
export const reducers = {
  common: commonSlice.reducer,
  history: historySlice.reducer,
  design: designSlice.reducer,
  snackbar: snackbarSlice.reducer,
  credit: creditSlice.reducer,
  whatsNew: whatsNewSlice.reducer,
  chatbot: chatbotSlice.reducer,
  guidance: guidanceSlice.reducer,
  notifications: notificationsSlice.reducer,
  siteImages: siteImagesSlice.reducer,
  reports: reportsSlice.reducer,
};

/** Shared by the app store and test stores, so a test sees the same serializability warnings. */
export const serializableCheck = {
  ignoredActionPaths: ["payload.icon"],
  ignoredPaths: [/^common\.snackbar\.\d+\.icon(\..+)?$/],
};
